var React = require('react');

function PlayButton (props) {
    return React.createElement("svg",props,[React.createElement("path",{"className":"play-button__fill","d":"m0 0h125v80h-125z","fill":"#404cfa","key":0}),React.createElement("path",{"clipRule":"evenodd","d":"m53 22v36l26-18z","fill":"#fff","fillRule":"evenodd","key":1})]);
}

PlayButton.defaultProps = {"className":"play-button","enableBackground":"new 0 0 125 80","height":"80","viewBox":"0 0 125 80","width":"125"};

module.exports = PlayButton;

PlayButton.default = PlayButton;
